import axios from "../../utils/axiosConfig";

import { AddManufacturerDTO, PaginationDTO } from "../../dtos/manufacturer";
 
axios.defaults.withCredentials = true;

const getManufacturer = async (dto?: PaginationDTO) => {
  let url = "/api/pharmacy/manufacturer/get"; // Base URL

  // If dto exists, add query parameters
  if (dto) {
    url += `?page=${encodeURIComponent(dto.page)}&limit=${encodeURIComponent(dto.limit)}&search=${encodeURIComponent(dto.search)}`;
  }

  const { data } = await axios.get(url);
  return data;
};



const AddManufacturer = async (manufacturer: AddManufacturerDTO ) => {
  const { data } = await axios.post( `/api/pharmacy/manufacturer/add`, manufacturer);

  return data;
};
const ManufacturerService = {
  getManufacturer,
  AddManufacturer,
};

export default ManufacturerService;
